import { type QMenuProps } from 'quasar';

import { ICONS_NAME } from './icons.constants';

export const EXPAND_ITEM_PROPS = {
    class: 'rounded-borders text-body1 bg-white',
    expandIconClass: 'text-primary-darker',
    expandIcon: ICONS_NAME.CHEVRON_DOWN_SOLID
};

export const EXPAND_ITEM_HEADER_PROPS = {
    class: 'expansion-item-header'
};

export const BORDERLESS_ITEM = {
    class: 'no-border'
};

export const DATE_PICKER_ITEM = {
    self: 'top left',
    anchor: 'bottom left',
    offset: [10, 16]
};

export const MENU_TOP_LEFT: QMenuProps = {
    self: 'bottom left',
    anchor: 'top left',
    offset: [0, 8]
};

export const MENU_TOP_RIGHT: QMenuProps = {
    self: 'bottom right',
    anchor: 'top right',
    offset: [0, 8]
};

export const MENU_BOTTOM_LEFT: QMenuProps = {
    self: 'top left',
    anchor: 'bottom left',
    offset: [0, 8]
};

export const MENU_BOTTOM_RIGHT: QMenuProps = {
    self: 'top right',
    anchor: 'bottom right',
    offset: [0, 8]
};

export const ITEM_MENU = {
    class: 'text-grey-dark rounded-borders'
};

export const ITEM_MENU_NEGATIVE = {
    class: 'text-negative rounded-borders'
};
